import React from "react";
import "./Users.scss";
import { Grid } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import { Text, SVG } from "sunrise-ui";
import dateFormat from "../../utilities/dateFormat";
import EnlargeImage from "./EnlargeImage";

const UserDetailDrawer = ({ drawerData }: { drawerData: any }) => {
  //------------------for right drawer modal--------
  const [drawerState, setDrawerState] = React.useState(false);
  const togglerDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      setDrawerState(open);
    };
  React.useEffect(() => {
    setDrawerState(drawerData.isOpen);
  }, [drawerData]);

  // ---------------for enlarge image modal-------------
  const [modalData, setModalData] = React.useState({
    image: "",
    isOpen: false,
  });

  const handleOpen = (photo: string) => {
    setModalData({ ...modalData, image: photo, isOpen: true });
  };
  // console.warn(drawerData);
  return (
    <Grid>
      <Drawer open={drawerState} anchor="right" onClose={togglerDrawer(false)}>
        <div className="right_drawer_page">
          <Grid container className="drwaer_container p1">
            <Grid item xs={11}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb0 mt0 capitalize"
              >
                {drawerData?.details?.role?.replace("-", " ")} Details
              </Text>
            </Grid>
            <Grid
              item
              xs={1}
              className="pointer"
              onClick={togglerDrawer(false)}
            >
              <SVG type={"close"} />
            </Grid>
            {/* -----------------------general detail---------- ------------*/}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb1 mt1"
              >
                General Details
              </Text>
            </Grid>
            <Grid
              item
              xs={12}
              container
              spacing={1}
              className="right_drawer_details_container"
            >
              {/* ---------name--------- */}
              <Grid item xs={12} container>
                <Grid item xs={5}>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="mb0 mt0"
                  >
                    <span className="fw400">
                      {drawerData?.details?.role
                        ?.toLowerCase()
                        ?.replace("-", " ") === "sub contractor"
                        ? "Company Name"
                        : "Name"}
                    </span>
                  </Text>
                </Grid>
                <Grid item xs={7}>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="mb0 mt0"
                  >
                    <span className="float-right capitalize">
                      {/* {drawerData?.details?.name} */}
                      {drawerData?.details?.role
                        ?.toLowerCase()
                        ?.replace("-", " ") === "sub contractor"
                        ? drawerData?.details?.subContractor?.companyName
                        : drawerData?.details?.name}
                    </span>
                  </Text>
                </Grid>
              </Grid>
              {/* ---------owner/Representative name--------- */}
              <Grid
                item
                xs={12}
                container
                className={
                  drawerData?.details?.role
                    ?.toLowerCase()
                    ?.replace("-", " ") !== "sub contractor"
                    ? "d-none"
                    : ""
                }
              >
                <Grid item xs={5}>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="mb0 mt0"
                  >
                    <span className="fw400">Representative Name</span>
                  </Text>
                </Grid>
                <Grid item xs={7}>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="mb0 mt0"
                  >
                    <span className="float-right capitalize">
                      {drawerData?.details?.role
                        ?.toLowerCase()
                        ?.replace("-", " ") === "sub contractor"
                        ? drawerData?.details?.subContractor?.ownerName
                        : ""}
                    </span>
                  </Text>
                </Grid>
              </Grid>
              {/* ----------address----------- */}
              <Grid item xs={12} container>
                <Grid item xs={4}>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="mb0 mt0"
                  >
                    <span className="fw400">Address</span>
                  </Text>
                </Grid>
                <Grid item xs={8}>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="mb0 mt0"
                  >
                    <span className="float-right">
                      {drawerData?.details?.address}
                    </span>
                  </Text>
                </Grid>
              </Grid>
              {/* ----------Email----------- */}
              <Grid item xs={12}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">Email Id</span>
                  <span className="float-right">
                    {drawerData?.details?.emailId}
                  </span>
                </Text>
              </Grid>
              {/* ----------Phone Number----------- */}
              <Grid item xs={12}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">Phone Number</span>
                  <span className="float-right">
                    {drawerData?.details?.mobileNumber?.primaryNumber}
                  </span>
                </Text>
              </Grid>
              {/* ----------Alternate Phone Number----------- */}
              <Grid item xs={12}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">Alternate Number</span>
                  <span className="float-right">
                    {drawerData?.details?.mobileNumber?.secondaryNumber}
                  </span>
                </Text>
              </Grid>
              {/* ----------DOB----------- */}
              <Grid
                item
                xs={12}
                className={
                  drawerData?.details?.role
                    ?.toLowerCase()
                    ?.replace("-", " ") === "sub contractor"
                    ? "d-none"
                    : ""
                }
              >
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">Date of Birth</span>
                  <span className="float-right">
                    {dateFormat(
                      drawerData?.details?.dateOfBirth?.split("T")[0]
                    )}
                  </span>
                </Text>
              </Grid>
              {/* ----------Anniversary Date----------- */}
              <Grid
                item
                xs={12}
                className={
                  drawerData?.details?.role
                    ?.toLowerCase()
                    ?.replace("-", " ") === "sub contractor"
                    ? "d-none"
                    : ""
                }
              >
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">Anniversary Date</span>
                  <span className="float-right">
                    {dateFormat(
                      drawerData?.details?.anniversaryDate?.split("T")[0]
                    )}
                  </span>
                </Text>
              </Grid>
            </Grid>
            {/* ---------------------Employee detail---------- ------------*/}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb1 mt1"
              >
                Employee Details
              </Text>
            </Grid>
            <Grid
              item
              xs={12}
              container
              spacing={1}
              className="right_drawer_details_container"
            >
              {/* ---------emp id--------- */}
              <Grid
                item
                xs={12}
                className={
                  drawerData?.details?.role
                    ?.toLowerCase()
                    ?.replace("-", " ") === "sub contractor"
                    ? "d-none"
                    : ""
                }
              >
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">Employee Id</span>
                  <span className="float-right">
                    {drawerData?.details?.empId}
                  </span>
                </Text>
              </Grid>
              {/* ---------designation--------- */}
              <Grid item xs={12}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400 capitalize">
                    {drawerData?.details?.role
                      ?.toLowerCase()
                      ?.replace("-", " ") === "operator" ||
                    drawerData?.details?.role
                      ?.toLowerCase()
                      ?.replace("-", " ") === "staff"
                      ? "Type"
                      : "Designation"}
                  </span>
                  <span className="float-right capitalize">
                    {drawerData?.details?.role
                      ?.toLowerCase()
                      ?.replace("-", " ") === "sub contractor"
                      ? drawerData?.details?.subContractor?.type
                      : drawerData?.details?.designation}
                  </span>
                </Text>
              </Grid>
              {/* ----------joining date----------- */}
              <Grid
                item
                xs={12}
                className={
                  drawerData?.details?.role
                    ?.toLowerCase()
                    ?.replace("-", " ") === "sub contractor"
                    ? "d-none"
                    : ""
                }
              >
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">Joining Date</span>
                  <span className="float-right">
                    {dateFormat(
                      drawerData?.details?.joiningDate?.split("T")[0]
                    )}
                  </span>
                </Text>
              </Grid>
              {/* ----------Aadhaar----------- */}
              <Grid item xs={12}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">Aadhaar Card Number</span>
                  <span className="float-right">
                    {drawerData?.details?.aadhar?.number}
                  </span>
                </Text>
              </Grid>
              {/* ----------Pan Number----------- */}
              <Grid item xs={12}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">PAN Card Number</span>
                  <span className="float-right">
                    {drawerData?.details?.pan?.number.toUpperCase()}
                  </span>
                </Text>
              </Grid>
              {/* ----------Employee type----------- */}
              <Grid
                item
                xs={12}
                className={
                  drawerData?.details?.role
                    ?.toLowerCase()
                    ?.replace("-", " ") === "sub contractor"
                    ? "d-none"
                    : ""
                }
              >
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">Employee Type</span>
                  <span className="float-right">
                    {drawerData?.details?.isPermanent === true
                      ? "Permanent"
                      : "Contaractual"}
                  </span>
                </Text>
              </Grid>
              {/* ----------Aadhaar/PAN image ----------- */}
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={6}>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb mt1 fw300"
                    >
                      Aadhaar Card Snapshot
                    </Text>
                    <Grid className="small_img_box t-center">
                      <img
                        src={drawerData?.details?.aadhar?.image}
                        alt="..."
                        className="pointer"
                        onClick={() => {
                          handleOpen(drawerData?.details?.aadhar?.image);
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb mt1 fw300"
                    >
                      PAN Card Snapshot
                    </Text>
                    <Grid className="small_img_box t-center">
                      <img
                        src={drawerData?.details?.pan?.image}
                        alt="..."
                        className="pointer"
                        onClick={() => {
                          handleOpen(drawerData?.details?.pan?.image);
                        }}
                      />
                    </Grid>
                  </Grid>
                  {(drawerData?.details?.role
                        ?.toLowerCase()==="operator")&&<Grid item xs={6}>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb mt1 fw300"
                    >
                      Driving License Snapshot
                    </Text>
                    <Grid className="small_img_box t-center">
                      <img
                        src={drawerData?.details?.license?.image}
                        alt="..."
                        className="pointer"
                        onClick={() => {
                          handleOpen(drawerData?.details?.license?.image);
                        }}
                      />
                    </Grid>
                  </Grid>}
                </Grid>
              </Grid>
            </Grid>
            {/* -----------Bank Detail--------- */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb1 mt1"
              >
                Bank Details
              </Text>
            </Grid>
            <Grid
              item
              xs={12}
              container
              spacing={1}
              className="right_drawer_details_container"
            >
              {/* ---------Bank Name-------- */}
              <Grid item xs={12}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">Bank Name</span>
                  <span className="float-right capitalize">
                    {drawerData?.details?.bankDetails?.name}
                  </span>
                </Text>
              </Grid>
              {/* ---------bank account number--------- */}
              <Grid item xs={12}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">Bank Account Number</span>
                  <span className="float-right">
                    {drawerData?.details?.bankDetails?.account}
                  </span>
                </Text>
              </Grid>
              {/* ----------ifsc code----------- */}
              <Grid item xs={12}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="mb0 mt0"
                >
                  <span className="fw400">IFSC Code</span>
                  <span className="float-right">
                    {drawerData?.details?.bankDetails?.ifsc}
                  </span>
                </Text>
              </Grid>

              {/* ----------passbook/user/GST image ----------- */}
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={6}>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb mt1 fw300"
                    >
                      Passbook Snapshot
                    </Text>
                    <Grid className="small_img_box t-center">
                      <img
                        src={drawerData?.details?.bankDetails?.image}
                        alt="..."
                        className="pointer"
                        onClick={() => {
                          handleOpen(drawerData?.details?.bankDetails?.image);
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb mt1 fw300"
                    >
                      {drawerData?.details?.role
                        ?.toLowerCase()
                        ?.replace("-", " ") === "sub contractor"
                        ? "GST Snapshot"
                        : " Candidate Snapshot"}
                    </Text>
                    <Grid className="small_img_box t-center">
                      <img
                        src={
                          drawerData?.details?.role
                            ?.toLowerCase()
                            ?.replace("-", " ") === "sub contractor"
                            ? drawerData?.details?.subContractor
                                ?.gstCertificateImage
                            : drawerData?.details?.userImage
                        }
                        alt="..."
                        className="pointer"
                        onClick={() => {
                          handleOpen(
                            drawerData?.details?.role
                              ?.toLowerCase()
                              ?.replace("-", " ") === "sub contractor"
                              ? drawerData?.details?.subContractor
                                  ?.gstCertificateImage
                              : drawerData?.details?.userImage
                          );
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Drawer>
      {/* ---------------Enlarge Image Modal---------- */}
      <EnlargeImage modalData={modalData} />
    </Grid>
  );
};

export default UserDetailDrawer;
